import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;



class ClosingBalance {
  create = async (date: any) => {
    const res = await axios.post<any>(`${API_URL}closing-balance`, date)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
    return res.data.transaction;
  };

  get = async (date: any) => {
    const response = await axios.get<any>(`${API_URL}general-ledger/${date}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.transaction;
  };

  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}account-transaction`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.accTransaction;
  };

  getAllTransactionType = async () => {
    const response = await axios.get<any>(`${API_URL}account-transaction-type`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.accTransactionType;
  };

  previewClosingBalance = async (values: any) => {
    const response = await axios.get<any>(`${API_URL}closing-balance-preview`, {
      params: {
        date: values.date,
        fromDate: `${values.date} 00:00:00`,
        toDate: `${values.date} 23:59:59`,
        task: values.task
      },
    }).catch((e) => {
      throw e.message;
    });
    return response.data.generalLedger;
  };

  LedgerAudit = async (values: any) => {
    const response = await axios.get<any>(`${API_URL}ledger-audit`, {
      params: {
        ledgerTypeCode: values.ledgerType?.code
      },
    }).catch((e) => {
      throw e.message;
    });
    return response.data.closingBalance;
  };

  // ... other methods ...

  getLastDate = async (key: any) => {
    const response = await axios.get<any>(`${API_URL}recent-closing-balance/${key ? key : 0}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.recentClosingBalance;
  };

  reversal = async (val: any) => {
    const response = await axios.put<any>(`${API_URL}closing-balance-reversal`, val)
      .catch((e) => {
        throw e.message;
      });
    return response.data.generalLedger;
  };
}

export default new ClosingBalance();